// export const BASE_URL = 'http://localhost:8000/api/'

// export const BASE_URL = "https://laiki.api.trackmis.com/";
export const isGlobal = window.location.pathname.startsWith("/global");
// export const BASE_URL = "https://dev.api.trackmis.com/";
export const BASE_URL = isGlobal
  ? "https://atcl.api.trackmis.com/"
  : "https://laiki.api.trackmis.com/";
